export default {
  'enabled-locations-map': {
    locations: 'ロケーション',
    'find-my-location': '自分のロケーションを見つける',
    'select-country': '国を選択',
    'all-countries': 'すべての国',
    search: '検索',
    filter: 'プロバイダー、都市、国、または州でフィルター',
    'location-type': 'ロケーションタイプ',
    '100G-enabled': '100G対応',
    'local-ix-available': 'ローカルIX利用可能',
    'mcr-enabled': 'MCR対応',
    'mve-enabled': 'MVE対応',
    'view-latency': 'レイテンシーを表示',
    'enquire-about-this-location': 'このロケーションについて問い合わせる',
    'enabled-location': '有効化されたロケーション',
    'extended-location': '拡張ロケーション',
    'loading-locations': 'ロケーションを読み込んでいます',
    'no-location-found': 'フィルター条件に合致するロケーションがありません',
    'closest-mp-enabled-location': '最寄りのMegaport有効化ロケーション',
    'location-filter': 'ロケーションフィルター',
    'coming-soon': '近日公開',
    'enter-your-address': '住所を入力してください',
    'learn-about-enabled-extended-locations': '有効化されたロケーションと拡張ロケーションについて詳しく見る',
    'megaport-supported-location-types': 'Megaportは、私たちのネットワークにアクセスできる2種類のロケーションをサポートしています',
    'locations-by-distance': '距離によるロケーション',
    'map-showing-data-center-location': 'データセンターの場所を示す地図',
  },
}
  
